var _path, _g, _path2, _g2, _g3, _g4, _path3, _g5, _path4, _ellipse, _g6, _path5, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReactionOutOfThisWorld(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 79,
    viewBox: "0 0 78 79",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3003_69890)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3003_69890",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 25,
    width: 26,
    height: 20
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.8166 25.582L10.8672 44.5471C14.3021 43.0334 18.1765 42.602 21.9261 43.4042L24.3859 38.9029L29.3127 38.1096L35.8865 26.7235L35.4948 26.4973C31.9999 29.1007 27.7056 29.763 24.3306 27.8144C23.3327 27.2383 22.4923 26.4785 21.8166 25.582Z",
    fill: "#F85A17"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3003_69890)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 53.2373,
    cy: 54.6474,
    r: 41.7455,
    transform: "rotate(35.0623 53.2373 54.6474)",
    fill: "#F85A17"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_3003_69890)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.1934 26.3359L24.3986 38.8246L30.6429 38.1307L36.1934 26.3359Z",
    fill: "#262626"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_3003_69890)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.1211 43.4355L12.5376 43.8801L15.5505 37.609L25.1211 43.4355Z",
    fill: "#FBF2C3"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_3003_69890",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 34,
    y: 42,
    width: 19,
    height: 26
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.9807 56.7482L34.0177 67.6965C35.5315 64.261 35.9626 60.3858 35.1597 56.6357L39.6596 54.1766L40.4525 49.2525L51.84 42.678L52.0656 43.0688C49.4617 46.5639 48.7991 50.8586 50.7479 54.2339C51.3241 55.232 52.0841 56.0725 52.9807 56.7482Z",
    fill: "#F85A17"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_3003_69890)"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 41.7455,
    transform: "matrix(-0.574467 -0.818528 -0.818528 0.574467 23.9132 25.3272)",
    fill: "#F85A17"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_3003_69890)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52.2275 42.3711L39.7389 54.1659L40.4327 47.9216L52.2275 42.3711Z",
    fill: "#262626"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_f_3003_69890)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.127 53.4414L34.6824 66.0249L40.9535 63.012L35.127 53.4414Z",
    fill: "#FBF2C3"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_f_3003_69890)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.7865 56.873C25.696 60.9635 16.751 62.2057 16.751 62.2057C16.751 62.2057 17.9932 53.2607 22.0837 49.1702C26.1742 45.0797 31.2146 43.488 33.3416 45.6151C35.4687 47.7421 33.877 52.7825 29.7865 56.873Z",
    fill: "url(#paint0_radial_3003_69890)"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_f_3003_69890)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54.3016 43.0266C47.704 49.6242 38.177 51.2294 32.4136 51.554C29.5215 51.7168 27.2432 49.4385 27.4061 46.5464C27.7306 40.783 29.3358 31.256 35.9334 24.6584C42.5997 17.9921 52.0618 16.6177 57.6741 16.4475C60.4384 16.3637 62.5963 18.5216 62.5125 21.2859C62.3423 26.8982 60.968 36.3603 54.3016 43.0266Z",
    fill: "#CCA2F8"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_3003_69890",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 27,
    y: 16,
    width: 36,
    height: 36
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M54.3016 43.0266C47.704 49.6242 38.177 51.2294 32.4136 51.554C29.5215 51.7168 27.2432 49.4385 27.4061 46.5464C27.7306 40.783 29.3358 31.256 35.9334 24.6584C42.5997 17.9921 52.0618 16.6177 57.6741 16.4475C60.4384 16.3637 62.5963 18.5216 62.5125 21.2859C62.3423 26.8982 60.968 36.3603 54.3016 43.0266Z",
    fill: "url(#paint1_linear_3003_69890)"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_3003_69890)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_f_3003_69890)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.8604 29.3223L21.7875 39.9877L27.1202 39.3952L31.8604 29.3223Z",
    fill: "#262626"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M42.9032 12.9493L44.4098 14.1302C52.0141 20.0903 58.8707 26.9469 64.8307 34.5511L66.0116 36.0577L52.0065 50.0628L50.8256 48.5562C44.8656 40.952 38.009 34.0954 30.4047 28.1353L28.8981 26.9544L42.9032 12.9493Z",
    fill: "#FBF2C3"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M39.4465 31.8038C40.5651 32.9225 42.1383 33.2547 43.669 33.0182C45.2005 32.7816 46.7664 31.9736 48.0461 30.6939C49.3258 29.4142 50.1338 27.8484 50.3703 26.3169C50.6068 24.7862 50.2746 23.2129 49.156 22.0943C48.0374 20.9757 46.4641 20.6435 44.9334 20.8799C43.4019 21.1165 41.836 21.9245 40.5564 23.2042C39.2767 24.4839 38.4687 26.0498 38.2321 27.5812C37.9956 29.112 38.3278 30.6852 39.4465 31.8038Z",
    fill: "black",
    stroke: "#F85A17",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_3003_69890",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 39,
    y: 21,
    width: 11,
    height: 12
  }, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 44.3012,
    cy: 26.9491,
    rx: 4.29602,
    ry: 5.86568,
    transform: "rotate(45 44.3012 26.9491)",
    fill: "#FBF2C3"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_3003_69890)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_f_3003_69890)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 44.3012,
    cy: 26.9491,
    rx: 4.29602,
    ry: 5.86568,
    transform: "rotate(45 44.3012 26.9491)",
    fill: "#FBF2C3"
  })))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.2304 51.245L27.7126 44.7273L26.529 44.7273L26.5283 44.7266L26.5276 44.7273L24.7508 46.5041L32.4535 54.2069L34.2304 52.4301L34.2311 52.4294L34.2304 52.4286L34.2304 51.245Z",
    fill: "url(#paint2_linear_3003_69890)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_3003_69890",
    x: 20.3984,
    y: 22.3359,
    width: 19.7949,
    height: 20.4883,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_3003_69890"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_3003_69890",
    x: 8.53711,
    y: 33.6094,
    width: 20.584,
    height: 14.2715,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_3003_69890"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_3003_69890",
    x: 35.7393,
    y: 38.3711,
    width: 20.4883,
    height: 19.7949,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_3003_69890"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_3003_69890",
    x: 30.6826,
    y: 49.4414,
    width: 14.2705,
    height: 20.584,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_3003_69890"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_f_3003_69890",
    x: 15.751,
    y: 43.6719,
    width: 19.5342,
    height: 19.5332,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    result: "effect1_foregroundBlur_3003_69890"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_f_3003_69890",
    x: 26.3975,
    y: 15.4453,
    width: 37.1172,
    height: 37.1172,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    result: "effect1_foregroundBlur_3003_69890"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_f_3003_69890",
    x: 17.7871,
    y: 25.3223,
    width: 18.0732,
    height: 18.666,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_3003_69890"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_f_3003_69890",
    x: 29.1602,
    y: 11.8086,
    width: 30.2822,
    height: 30.2812,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "effect1_foregroundBlur_3003_69890"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_3003_69890",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(25.9351 53.0216) rotate(135) scale(10.4744 5.4467)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.723958,
    stopColor: "#FBF2C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F85A17"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3003_69890",
    x1: 53.1914,
    y1: 7.40039,
    x2: 71.9241,
    y2: 27.0467,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CCA2F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515625,
    stopColor: "#F7CFDA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CEECB5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3003_69890",
    x1: 27.1202,
    y1: 44.7272,
    x2: 31.8592,
    y2: 54.8002,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBF2C3"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3003_69890"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 78,
    height: 78,
    fill: "white",
    transform: "translate(0 0.228516)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReactionOutOfThisWorld);
export default __webpack_public_path__ + "static/media/reaction_out-of-this-world.195a0085acf782b2f10b591f0bddd2ff.svg";
export { ForwardRef as ReactComponent };